import { render, staticRenderFns } from "./TwoFactorAuth.vue?vue&type=template&id=36b767f4&scoped=true"
import script from "./TwoFactorAuth.vue?vue&type=script&lang=js"
export * from "./TwoFactorAuth.vue?vue&type=script&lang=js"
import style0 from "./TwoFactorAuth.vue?vue&type=style&index=0&id=36b767f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b767f4",
  null
  
)

export default component.exports